import { useHandleQueryErrorWithToast } from '@/features/shiftCloseouts/hooks/useHandleQueryErrorWithToast'
import { ShiftCloseoutsQuery } from '@/features/shiftCloseouts/queries'
import { ShiftCloseoutHistoryItem } from '@/features/shiftCloseouts/types'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

const shiftCloseoutHistoryLimit = 5

export const useShiftCloseouts = (): ShiftCloseoutHistoryItem[] => {
    const { data, error, loading } = useQuery(ShiftCloseoutsQuery, {
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    })

    useHandleQueryErrorWithToast(error, loading)

    return useMemo(
        () =>
            data?.shiftCloseouts
                .map<ShiftCloseoutHistoryItem>((shiftCloseout) => ({
                    closedAt: shiftCloseout.closedAt,
                    profileName: shiftCloseout.closedByName ?? undefined,
                    totalAmount: shiftCloseout.totalAmount,
                    uuid: shiftCloseout.uuid,
                }))
                .slice(0, shiftCloseoutHistoryLimit) ?? [],
        [data?.shiftCloseouts]
    )
}
